module.exports = __webpack_public_path__ + "assets/img/3_1295.ee7c89ed.jpg";